const NS = 'PersonBioBlock';
const CLS = 'personBioBlock';

import { handleTruncate } from '../../../../global/js/truncate';
import { mediaQuery } from '../../../../global/js/wool/mediaQuery';

export class PersonBioBlock {
	constructor(element) {
		this.$element = $(element);
		this.mediaQuery = mediaQuery;

		this.truncation();
	}

	// Only truncate text for mobile devices
	truncation() {
		if(this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.SM)) {
			this.limit = 450; // reserved limit (characters)

			this.$summary = this.$element.find(`.${CLS}-description`);
			this.summaryHtml = this.$summary.html();
			this.summaryText = this.$summary.text(); // for comparison without the extra characters from html tags
			this.originalHtml = this.summaryHtml;

			// handle truncate (read more / read less)
			handleTruncate(this);
		}
	}
}
